module.exports = __webpack_public_path__ + "img/storm.b8a9dceb.svg";